export default __webpack_public_path__ + "static/media/quicksand.8b459719.png";